const messages = {
	signUpSuccess: "Successfully registered! You've been signed in as well.",
	signUpFailure:"Registration failed. Email may be taken, or passwords don't match.",
	signInSuccess: 'Welcome!',
	signInFailure:'Failed to sign in. Check your email and password and try again.',
	signOutSuccess: 'Come back soon!',
	changePasswordSuccess: 'Password changed successfully!',
	changePasswordFailure:'Failed to change passwords. Check your old password and try again.',
	getExpensesFailure:'Error fetching Expenses',
	createExpenseSuccess:'Expense Created Successfully!',
	createExpenseFailure:'Something went wrong! Please try again.',
	updateExpenseSuccess:'Expense updated successfully!',
	updateExpenseFailure:'Something went wrong! THIS SHIT SUCKS Please try again!',
	removeExpenseSuccess:'Expense deleted!',
	removeExpenseFailure:'Could not delete Expense! Please try again!',
}

module.exports = messages